import React from "react";
import "./TermsAndConditions.css"
import Footer from "../../Components/Footer/Footer";
import Scrolling from "../../Components/Scrolling/Scrolling";
const TermsAndConditions = () => {
  return (
    <>
    <div className="TermsCnd_main_container" >
      <h1 className="TermsHeaderName">Terms and Conditions</h1>
      <div className="termscnd_container">
        <div className="termscnd_div_1">
          <h2 >Acceptance of Terms</h2>
          <p >
            Welcome to Oraddo, a cloud-based Business Process Management System.
            By accessing or using our platform, you agree to comply with and be
            bound by these Terms and Conditions. If you do not agree, please
            refrain from using our services.
          </p>
        </div>
        <div className="termscnd_div_2">
          <h2> Services Provided</h2>
          <p>
            Oraddo provides tools for managing human resources, business
            processes, and related operations. Services are subscription-based
            and include access to our web platform, mobile application, and
            customer support.{" "}
          </p>
        </div>
        <div className="termscnd_div_3">
          <h2 > User Responsibilities</h2>
          <ul >
            <li>
              Ensure that all information provided during registration is
              accurate and up to date.
            </li>
            <li>Maintain the confidentiality of your account credentials.</li>
            <li>
              Use the platform in compliance with all applicable laws and
              regulations.
            </li>
            <li>Avoid unauthorized access or misuse of the system.</li>
          </ul>
        </div>
        <div className="termscnd_div_4">
          <h2 > Subscription and Billing</h2>
          <ul >
            <li>
              Subscriptions are billed on a monthly or annual basis, as per the
              chosen plan.
            </li>
            <li>
              Payments must be made through the approved payment gateways.
            </li>
            <li>
              Failure to pay may result in suspension or termination of
              services.
            </li>
          </ul>
        </div>
        <div className="termscnd_div_5">
          <h2 >Intellectual Property</h2>
          <p>
            All content, trademarks, and software associated with Oraddo are the
            exclusive property of Oraddo. Users are prohibited from reproducing,
            distributing, or modifying any part of the platform without prior
            consent.
          </p>
        </div>
        <div className="termscnd_div_6">
          <h2 > Data Security</h2>
          <p>
            While we implement industry-standard security measures, Oraddo is
            not liable for any data breaches resulting from factors beyond our
            control.
          </p>
        </div>
        <div className="termscnd_div_7">
          <h2 >Termination </h2>
          <p>
            Oraddo reserves the right to terminate or suspend access to the
            platform for violations of these terms or any unauthorized activity.
          </p>
        </div>
        <div className="termscnd_div_8">
          <h2 > Limitation of Liability</h2>
          <p>
            Oraddo shall not be held liable for indirect, incidental, or
            consequential damages arising from the use of the platform.
          </p>
        </div>
        <div className="termscnd_div_9">
          <h2 >Amendments </h2>
          <p>
            We may update these Terms and Conditions from time to time.
            Continued use of the platform constitutes acceptance of the updated
            terms
          </p>
        </div>
        <div className="termscnd_div_10">
          <h2 >Governing Law</h2>
          <p>These terms are governed by the laws of [your jurisdiction].</p>
        </div>
        <div className="termscnd_div_11">
          <h2 >Contact Us</h2>
          <p>
            For any questions or concerns, you can contact us at: Oraddo
            <ul className="noStyle">
                <li>Oraddo Technologies Hitech City Road, Khanamet, </li>
                <li> beside Yashoda Hospital,</li>
                <li>opposite Bharat Petrol Bunk,</li>
                <li>HITEC City, Hyderabad, Telangana 500084 </li>
                <li><strong>Email:</strong> support@oraddo.com</li>
              </ul>
          </p>
        </div>
      </div>

    
    </div>
    <div className="footer_termscnd"> 
         <Footer />
      <Scrolling />
       </div>
    </>
  );
};

export default TermsAndConditions;
